import Img from "gatsby-image"
import { FluidImage } from "model/content"
import React, { forwardRef } from "react"
import styled, { css } from "styled-components"
import { breakpoint } from "styles/breakpoints"
import tw from "twin.macro"

type PhotoTileProps = {
  image: FluidImage
  photosCountToShow: number
  photoHeightPx?: number
}

const PhotoTileContainer = styled.div`
  ${tw`flex h-full -mr-px`};
  ${tw`text-dominant border border-gray-100 bg-dominant`}
  width: 18rem;

  ${({ photosCountToShow, photoHeightPx }) =>
    css`
      width: ${100 / photosCountToShow}vw;
      height: ${photoHeightPx}px;
    `}
`

const PhotoTileInner = styled.div`
  ${tw`relative flex flex-col lg:block w-full h-full transition duration-500`}
  transform-style: preserve-3d;
`

const FrontSide = styled.div`
  ${tw`flex flex-col justify-center items-center h-48`}
  z-index: 0;
`

const BgImg = styled(Img)`
  ${tw`inset-0 w-full h-full`}
  position: absolute !important;
`

const PhotoTile = forwardRef<HTMLDivElement, PhotoTileProps>(
  function PhotoTileWithRef(
    { image, photosCountToShow, photoHeightPx = 270 },
    ref
  ) {
    return (
      <PhotoTileContainer
        ref={ref}
        photosCountToShow={photosCountToShow}
        photoHeightPx={photoHeightPx}
      >
        <PhotoTileInner>
          <FrontSide>
            <BgImg fluid={image.fluid} />
          </FrontSide>
        </PhotoTileInner>
      </PhotoTileContainer>
    )
  }
)

export default PhotoTile
